document.addEventListener('DOMContentLoaded', function () {
  var rotateTriggers = document.querySelectorAll('[data-rotate-trigger]');

  rotateTriggers.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var card = document.querySelector('#' + this.getAttribute('data-rotate-trigger'));
      var dataUrl = card.getAttribute('data-url');
      var currentHash = window.location.hash.substring(1);

      if (dataUrl !== currentHash) {
        window.location.hash = dataUrl;
        card.classList.toggle('flip');
      } else {
        card.classList.toggle('flip');
      }
    });
  });

  if (window.location.hash) {
    var hash = window.location.hash.substring(1);
    var targetCard = Array.from(document.querySelectorAll('[data-url]')).find(
      (card) => card.getAttribute('data-url') === hash
    );
    if (targetCard) {
      targetCard.classList.add('flip');
    }
  }
});
